import { Button } from './ui/button';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';

const WHATSAPP_URL = import.meta.env.VITE_WHATSAPP_URL;

export function CTA() {
  const { toast } = useToast();

  const handleWhatsApp = () => {
    if (WHATSAPP_URL) {
      window.open(WHATSAPP_URL, '_blank');
    } else {
      toast({
        title: 'Em breve',
        description: 'Funcionalidade de WhatsApp será disponibilizada em breve.',
      });
    }
  };

  return (
    <section className="py-24 md:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary/90 via-primary to-primary/80 p-10 md:p-16 shadow-2xl">
            {/* Background decoration */}
            <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-96 h-96 bg-white/10 rounded-full blur-3xl" />
            <div className="absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 w-96 h-96 bg-black/10 rounded-full blur-3xl" />
            
            <div className="relative z-10 text-center space-y-6 max-w-3xl mx-auto">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-primary-foreground">
                Pronto para Comprar com Inteligência?
              </h2>
              <p className="text-lg text-primary-foreground/80 max-w-xl mx-auto">
                Junte-se a milhares de compradores que economizam usando nossa plataforma de análise inteligente
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
                <Button 
                  size="lg" 
                  variant="secondary" 
                  asChild 
                  className="group text-base px-8 shadow-lg hover:shadow-xl transition-shadow"
                >
                  <Link to="/demo">
                    Começar Análise Grátis
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </Button>
                <Button 
                  size="lg" 
                  variant="outline" 
                  onClick={handleWhatsApp}
                  className="text-base px-8 bg-transparent border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground"
                >
                  <MessageCircle className="mr-2 w-4 h-4" />
                  Falar com Especialista
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
